<template>
  <div class="comp-modal">
    <div
    v-on:click="onClickBackground()" ontouchstart=""
    class="modal-background"></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'comp-modal',
  methods: {
    onClickBackground: function () {
      this.closeModalRequest()
    },
    closeModalRequest: function () {
      this.$emit('closeModalRequest')
    }
  }
}
</script>

<style scoped>
.comp-modal {
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.modal-background {
  /* common */
  background-color: black;
  opacity: 0.7;
  /* size */
  width: 100%;
  height: 100%;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}

.flex-end {
  justify-content: end;
}

.action-btns {
  /* size */
  margin: 1em 0 2em;
  /* alignment */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1em;
}

.action-btn {
  /* common */
  background-color: white;
  color: var(--gray-high);
  white-space: nowrap;
  border-radius: 5px;
  border: 1px solid var(--border);
  -webkit-box-shadow: 0 0 5px 0 rgba(227,232,238,.42745098039215684);
  box-shadow: 0 0 5px 0 rgba(227,232,238,.42745098039215684);
  /* size */
  width: auto;
  padding: 0.5em 1em;
  /* mouse */
  cursor: pointer;
}
.action-btn.blue {
  /* common */
  background-color: var(--primary);
  color: #fff;
}

.label {
  font-size: 14px;
  color: var(--gray-high);
  text-align: start;
  margin-bottom: 10px;
}
input {
  /* common */
  background: white;
  border: solid 1px#e6e6e6;
  border-radius: 5px;
  /* size */
  width: calc(100% - 1em);
  padding: 0.5em;
  font-size: 16px;
  /* padding: 10px; */

  -webkit-transition: -webkit-box-shadow .3s;
  transition: -webkit-box-shadow .3s;
  transition: box-shadow .3s;
  transition: box-shadow .3s,-webkit-box-shadow .3s;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue